import React from 'react';
import PropTypes from 'prop-types';

const Modal = ({
  children,
  className,
  style,
}) => (
  <div style={style} className={`modal-container ${className}`}>
    {children}
  </div>
);

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.string,
};

Modal.defaultProps = {
  children: <div />,
  className: '',
  style: {},
};

export default Modal;
